import http from './api'

const route = 'app/comercial/cliente4/'

export default {
   showMelhoresClienteLitros: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades) => {
    return http.post(route + 'showMelhoresClienteLitros', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
    })
  },

  showFatPrincipaisClientesLitros: (primeiroDia, ultimoDia, select, supervisor, area, rede, vendedor, receita, tokencontrato, segmento, categoria, promotor, classificacao, linhaProducao, cidades) => {
    return http.post(route + 'showFatPrincipaisClientesLitros', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedor,
      supervisor: supervisor,
      area: area,
      rede: rede,
      receita: receita,
      tokenContrato: tokencontrato,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
    })
  },

  showFatClientesCidades: (primeiroDia, ultimoDia, select, supervisor, area, rede, vendedor, receita, tokencontrato, segmento, categoria, promotor, classificacao, linhaProducao, cidades) => {
    return http.post(route + 'showFatClientesCidades', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedor,
      supervisor: supervisor,
      area: area,
      rede: rede,
      receita: receita,
      tokenContrato: tokencontrato,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
    })
  },

  showSomenteClientes4Devolucao: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades) => {
    return http.post(route + 'showSomenteClientes4Devolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
    })
  },
// this.primeiroDia, this.ultimoDia, this.select, this.vendedorSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect, this.selectSegmento, this.selectCategoria, this.selectPromotor, this.selectClassificacao, this.linhaProducaoSelect, this.cidadesSelect
  showDetalheClientes4Devolucao: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades) => {
    return http.post(route + 'showDetalheClientes4Devolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
    })
  },
}
